module.exports = '<svg width="44" height="32" viewBox="0 0 44 32"><path d="M36.949 12.294h-.229C35.525 4.904 29.473 0 22.17 0 14.849 0 8.787 4.904 7.612 12.294H7.39c-4.325 0-7.39 5.2-7.39 9.853C0 27.566 4.409 32 9.853 32h24.632c5.444 0 9.804-4.409 9.804-9.828 0-4.582-3.104-9.878-7.34-9.878zm-21.948 6.023l6.372-8.262c.441-.579 1.153-.601 1.591-.025l6.372 8.301c.441.579.202 1.35-.53 1.35h-4.175v5.89c0 .677-.552 1.5-1.232 1.5h-2.463c-.68 0-1.232-.823-1.232-1.5v-5.887h-4.175c-.732 0-.971-.786-.53-1.367z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cloud-upload-1.js
// module id = 1076
// module chunks = 14